import {
  HStack,
  Image,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay
} from "@chakra-ui/react";

import { useDispatch, useSelector } from "react-redux";

import {
  IBank,
  IBankConnection
} from "@/jenesys-types/jenesys-entities/config";

import {
  authorizeYapily,
  selectConnectionsSettings
} from "@/store/features/clientSettings/connections/connections";

import { ReviewBankDetails } from "./ConnectBank/ReviewBankDetails";

interface Props {
  isOpen: boolean;
  onClose: () => void;
  connection: IBankConnection & { bank?: IBank };
}

export function ReAuthoriseConnection({ isOpen, connection, onClose }: Props) {
  const dispatch = useDispatch();
  const { isFetchingYapilyAuthURL } = useSelector(selectConnectionsSettings);

  const confirmBankDetails = () => {
    dispatch(
      authorizeYapily({
        companyId: connection.company_id,
        institutionId: connection?.bank!.institution_id,
        onSuccess: (url: string) => {
          window.location.href = url;
        }
      })
    );
  };

  return (
    <Modal
      closeOnOverlayClick={false}
      onClose={onClose}
      isOpen={isOpen}
      isCentered
    >
      <ModalOverlay />
      <ModalContent maxW={440} rounded={16} fontWeight={500} px={6} py={4}>
        <ModalHeader p={0}>
          <HStack justify="center">
            <Image width={103} src="/images/logo.png" alt="Jenesys Logo" />
          </HStack>
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody px={0} pt={5}>
          <ReviewBankDetails
            bank={connection!.bank!}
            isLoading={isFetchingYapilyAuthURL}
            confirmBankDetails={confirmBankDetails}
          />
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}
